export const EQCols = [{ 
    headerClassName: 'data-table header fixedNumber-l',
    className: 'fixedNumber-l',
    show: true,
    accessor: 'equipmentNumber',
    isActionLink: true,
    id: 'equipmentNumber-col-link',
    fieldHeader: 'Equipment/CLR number',
    sortable: true
},
{
    headerClassName: 'data-table header',
    show: true,
    accessor: 'productType',
    id: 'productType-col',
    fieldHeader: 'Product Type',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'status',
    id: 'status-col',
    fieldHeader: 'Status',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'size',
    id: 'size-col',
    fieldHeader: 'Size',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'type',
    id: 'type-col',
    fieldHeader: 'Type',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'sealNumber1',
    fieldHeader: 'Seal Number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'carrier',
    id: 'carrier-col',
    fieldHeader: 'Carrier Code',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'carrierBooking',
    id: 'carrierBooking-col',
    fieldHeader: 'Carrier Booking',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'etsNumber',
    id: 'etsNumber-col',
    fieldHeader: 'ETS Number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'placeOfReceiptCode',
    id: 'placeOfReceiptCode-col',
    fieldHeader: 'Place of Receipt',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'loadingPortCode',
    id: 'loadingPortCode-col',
    fieldHeader: 'Port of Loading',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'dischargePortCode',
    id: 'dischargePortCode-col',
    fieldHeader: 'Port of Discharge',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'placeOfDeliveryCode',
    id: 'placeOfDeliveryCode-col',
    fieldHeader: 'Place of Delivery',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'consginee',
    id: 'consignee-col',
    fieldHeader: 'Consignee',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'etd',
    id: 'etd-col',
    fieldHeader: 'ETD',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'eta',
    id: 'eta-col',
    fieldHeader: 'ETA',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedBy',
    id: 'lastChangedBy-col',
    fieldHeader: 'Last Changed By',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangeDate',
    id: 'lastChangeDate-col',
    fieldHeader: 'Last Change Date',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'id',
    id: 'eq-id-col',
    fieldHeader: 'ID',
    sortable: true
}]